import * as React from 'react';
import PropTypes from 'prop-types';
import Header from './common/Header';
import Footer from './common/Footer';
import SocialIcons from './common/SocialIcons';
import Icons from './common/Icons';
import SideMenu from './common/SideMenu';
import Modal from './common/Modal';
import BrowserWarning from './common/BrowserWarning';
import CookieMessage from './common/CookieMessage';
import MetaTags from 'react-meta-tags';
import * as browserCheck from '../utils/browserCheck.js';

class App extends React.Component {   
    render() {
        let baseUrl = null;
        
        //the static context seems to always be null in this component
        if(this.props.staticContext) {
            //we're rendering on the server
            baseUrl = this.props.staticContext.baseUrl;
        }
        else {
            baseUrl = browserCheck.canUseDom() ? window.location.origin: 'https://www.loudup.com';
        }
        
        const metaImageUrl = `${baseUrl}/${require('../images/loudup logo - facebook - 250.png')}`;
        const metaTitle = 'LoudUp - Music Social Network - Discover New Music';
        const metaDescription = 'Music social network for music lovers, artists, bands, musicians and more! Connect with fans, discover new music, and share the music you love with your friends.';
        const metaUrl = 'https://www.loudup.com';

        return (
            <div> 
                <MetaTags>
                    <title>{metaTitle}</title>
                    <meta id="og-image" property="og:image" content={metaImageUrl} />
                    <meta id="og-url" property="og:url" content={metaUrl} />
                    <meta id="description" name="description" content={metaDescription} />
                    <meta id="og-title" property="og:title" content={metaTitle} />
                    <meta id="og-description" property="og:description" content={metaDescription} />  
                    <meta id="twitter-url" name="twitter:url" content={metaUrl} />
                    <meta id="twitter-title" name="twitter:title" content={metaTitle} />
                    <meta id="twitter-description" name="twitter:description" content={metaDescription} />
                    <meta id="twitter-image" name="twitter:image" content={metaImageUrl} />                 
                </MetaTags>      
                <Icons />
                <SocialIcons />           
                <Header />         
                <SideMenu/>
                {this.props.children}
                <CookieMessage />
                <Footer />      
                {/*<Modal type="mainModal" />*/}
                <BrowserWarning />     
            </div>
        );
    }
}

App.propTypes = {
    children: PropTypes.object.isRequired,
    staticContext: PropTypes.object
};

export default App;